import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { CustomerSearchForm } from './customer-search-form';
export const CustomerSearch = () => {
    return (_jsx(_Fragment, { children: _jsx(CustomerSearchForm, {}) }));
};
